// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"remote-wave"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18 22V12H6V22M12 16H12.0039V16.0039H12V16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2.73633 7.07193C4.69159 4.02153 8.11167 2 12.0039 2C15.8961 2 19.3162 4.02153 21.2715 7.07193M6.9375 8.75479C8.00401 7.09093 9.8695 5.98828 11.9925 5.98828C14.1156 5.98828 15.9811 7.09093 17.0476 8.75479","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RemoteWaveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'remote-wave',
    ref,
    icon: element,
  },
));

RemoteWaveIcon.displayName = 'RemoteWaveIcon';

export default RemoteWaveIcon;
